<template>
    <button
        type="submit"
        class="migrate-btn"
        :class="{disabled: migrateBtnProcessing}"
        :disabled="migrateBtnProcessing"
        @click="migrateBtnHandler"
    >
        <div class="wrap">
            <or-progress-circular
                v-if="migrateBtnProcessing"
                class="processing-icon"
                color="white"
                size="16"
            />

            <span v-else class="label">
              {{ $t('model.nlu-model.header.migratebutton.label') }}
            </span>
        </div>
    </button>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('knowledgebase', ['categories', 'migrateBtnProcessing'])
  },

  methods: {
    migrateBtnHandler () {
      KnowledgeBus.$emit('migrate-confirm::open')
    }
  }
}
</script>

<style lang="scss" scoped>
    .migrate-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 112px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: none;
        font-size: 14px;
        color: $or-white;
        background-color: $or-yellow;

        &:hover {
            background-color: darken($or-yellow, 2%);
            transition: all .2s ease;
            cursor: pointer;
        }

        &.disabled {
            justify-content: center;
            padding: 0;
            background-color: lighten($or-yellow, 20%);
            cursor: auto;

            &:hover {
                background-color: lighten($or-yellow, 5%);
            }
        }

        .wrap {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
</style>
